<!--

  Public methods:
    - isFocus() force to emit this page is visible
-->

<template>
  <canvas ref="page" v-visible="isFocus" v-visible.once="drawPage" v-bind="canvasAttrs" style="pointer-events: none;"></canvas>
</template>
  
<script>
  import visible from '@/components/pdf_viewer/directives/visible';
  
  export default {
    name: 'PDFPage',
    directives: {
      visible,
    },
    props: {
      page: {},
      scale: {},
      pageNumber: {},
    },

    data() {
      return {
        renderTask: null,
        viewport: null,
      }
    },
  
    computed: {
      pixel_ratio(){
        return devicePixelRatio || 1;
      }, 
      actualSizeViewport() {
        return this.viewport.clone({scale: this.scale});
      },

      canvasStyle() {
        const {width: actualSizeWidth, height: actualSizeHeight} = this.actualSizeViewport;
        const [pixelWidth, pixelHeight] = [actualSizeWidth, actualSizeHeight]
          .map(dim => Math.ceil(dim / this.pixel_ratio));

        return `width: ${pixelWidth}px; height: ${pixelHeight}px;`;
      },

      canvasAttrs() {
        let {width, height} = this.viewport;
        [width, height] = [width, height].map(dim => Math.ceil(dim));
        const style = this.canvasStyle;

        return {
          width,
          height,
          style,
          class: 'page box-shadow',
        };
      },

    },

    beforeDestroy() {
      this.destroyPage(this.page);
    },
    created() {
      this.viewport = this.page.getViewport({scale:this.scale});
    },

    methods: {
      isFocus() {
        this.$emit('isFocus',this.pageNumber);
      },
      destroyPage(page) {
        if (page) page._destroy();

        this.destroyRenderTask();
      },
      destroyRenderTask() {
        if (!this.renderTask) return;

        this.renderTask.cancel();
        delete this.renderTask;
      },
      drawPage() {
        if (!this.page || this.renderTask) return;

        let emitRender = () => {this.$emit('page-rendered',this.pageNumber);}
        let scale = this.scale ? this.scale : 1.5;
        let viewport = this.page.getViewport({scale: scale});

        this.viewport=viewport

        let canvas = this.$el;
        let context = canvas.getContext('2d');

        canvas.height = viewport.height;
        canvas.width = viewport.width;
          
        let renderContext = {
          canvasContext: context,
          viewport: viewport
        };
        this.renderTask = this.page.render(renderContext);
            
        this.renderTask.promise.then(function () {
          console.log('Page rendered');
          emitRender();
        })
        .catch(response => {
          this.destroyRenderTask();
        });   
      },
    },
  
    watch: {
      page () {
        this.viewport = this.page.getViewport({scale:this.optimalScale});
      },
    },
  
    
  };
</script>
<style>
.page {
  display: block;
  margin: 0 auto;
}
</style>
  